import * as log from "loglevel"
log.setDefaultLevel(process.env.NODE_ENV === "production" ? 2 : 0)
export default log
